import { render, staticRenderFns } from "./AccountingOnboaringComponent.vue?vue&type=template&id=c38fa29a&scoped=true"
import script from "./AccountingOnboaringComponent.vue?vue&type=script&lang=js"
export * from "./AccountingOnboaringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38fa29a",
  null
  
)

export default component.exports